// src/data/placementBank.js
// SAMPLE — 3 preguntas por nivel × 6 niveles × 3 skills = 54 preguntas
// Una vez validado el flujo, se expande a 8+ por celda

export const PLACEMENT_BANK = [

// ════════════════════════════════════════════════════════════
  // NIVEL A1 — Ser/Estar, Posesivos, Familia
  // 5 grammar · 9 vocabulary · 9 reading = 23 preguntas
  // ════════════════════════════════════════════════════════════

  // ── A1 GRAMMAR ───────────────────────────────────────────────
  {
    id: 'a1_g_01', level: 'A1', skill: 'grammar', type: 'mc',
    q: 'How ___ you today?',
    options: ['am', 'is', 'are', 'be'],
    a: 'are',
  },
  {
    id: 'a1_g_02', level: 'A1', skill: 'grammar', type: 'mc',
    q: 'Is ___ your phone over there on the table?',
    options: ['this', 'that', 'these', 'those'],
    a: 'that',
  },
  {
    id: 'a1_g_10', level: 'A1', skill: 'grammar', type: 'mc',
    q: 'That is not my bag. My bag ___ blue.',
    options: ['is', 'am', 'are', 'be'],
    a: 'is',
  },
  {
    id: 'a1_g_14', level: 'A1', skill: 'grammar', type: 'mc',
    q: 'I ___ at work today. I am at home.',
    options: ['am', 'is not', 'am not', 'are not'],
    a: 'am not',
  },
  {
    id: 'a1_g_16', level: 'A1', skill: 'grammar', type: 'mc',
    q: 'Does she ___ a brother?',
    options: ['has', 'have', 'having', 'haves'],
    a: 'have',
  },

  // ── A1 VOCABULARY ────────────────────────────────────────────
  {
    id: 'a1_v_01', level: 'A1', skill: 'vocabulary', type: 'mc',
    q: 'The person who helps sick animals is a ___.',
    options: ['Chef', 'Vet', 'Gardener', 'Artist'],
    a: 'Vet',
  },
  {
    id: 'a1_v_02', level: 'A1', skill: 'vocabulary', type: 'mc',
    q: 'What is the opposite of "expensive"?',
    options: ['Cheap', 'Old', 'Small', 'Quiet'],
    a: 'Cheap',
  },
  {
    id: 'a1_v_05', level: 'A1', skill: 'vocabulary', type: 'mc',
    q: 'I am from Brazil. I am ___.',
    options: ['Brazilian', 'Brazilish', 'Brazilean', 'Braziler'],
    a: 'Brazilian',
  },
  {
    id: 'a1_v_09', level: 'A1', skill: 'vocabulary', type: 'mc',
    q: 'The day before Wednesday is ___.',
    options: ['Monday', 'Wednesday', 'Tuesday', 'Thursday'],
    a: 'Tuesday',
  },
  {
    id: 'a1_v_10', level: 'A1', skill: 'vocabulary', type: 'mc',
    q: 'I work in a ___. I help students learn math.',
    options: ['hospital', 'farm', 'school', 'office'],
    a: 'school',
  },
  {
    id: 'a1_v_13', level: 'A1', skill: 'vocabulary', type: 'mc',
    q: 'I use a ___ to write in my notebook.',
    options: ['Ruler', 'Pen', 'Desk', 'Chair'],
    a: 'Pen',
  },
  {
    id: 'a1_v_14', level: 'A1', skill: 'vocabulary', type: 'mc',
    q: "My father's sister is my ___.",
    options: ['Uncle', 'Aunt', 'Cousin', 'Grandmother'],
    a: 'Aunt',
  },
  {
    id: 'a1_v_15', level: 'A1', skill: 'vocabulary', type: 'mc',
    q: 'I need a ___ to open the front door.',
    options: ['Lock', 'Key', 'Handle', 'Window'],
    a: 'Key',
  },
  {
    id: 'a1_v_16', level: 'A1', skill: 'vocabulary', type: 'mc',
    q: "My parent's son is my ___.",
    options: ['Sister', 'Brother', 'Father', 'Uncle'],
    a: 'Brother',
  },

  // ── A1 READING ───────────────────────────────────────────────
  {
    id: 'a1_r_01', level: 'A1', skill: 'reading', type: 'reading',
    passage: 'Hi! I am Marc. I am 22. I work in a hospital from Monday to Friday. I have a dog called Rex.',
    q: "What is Marc's job?",
    options: ['A vet', 'A doctor', 'A student', 'He is 22'],
    a: 'A doctor',
  },
  {
    id: 'a1_r_02', level: 'A1', skill: 'reading', type: 'reading',
    passage: "WANTED: Assistant at Marie's Cakes. Saturdays and Sundays only, 9am to 5pm. $12 per hour.",
    q: 'When is the work?',
    options: ['Every day', 'On the weekend', 'Monday to Friday', 'In the evening'],
    a: 'On the weekend',
  },
  {
    id: 'a1_r_05', level: 'A1', skill: 'reading', type: 'reading',
    passage: "My brother's name is Sam. He is a chef in a small restaurant. He works on Saturdays and Sundays.",
    q: 'What does Sam do on the weekend?',
    options: ['He visits his brother', 'He works in a kitchen', 'He goes to a restaurant', 'He sleeps'],
    a: 'He works in a kitchen',
  },
  {
    id: 'a1_r_09', level: 'A1', skill: 'reading', type: 'reading',
    passage: 'To: Sarah. Hi! I am in London. The weather is cold but beautiful. I have a new camera for my photos. See you soon, Marc.',
    q: 'What does Marc have?',
    options: ['A new bag', 'A new camera', 'A blue phone', 'A cold coat'],
    a: 'A new camera',
  },
  {
    id: 'a1_r_10', level: 'A1', skill: 'reading', type: 'reading',
    passage: 'My house is small. It has one bedroom, a kitchen, and a living room. I do not have a garden.',
    q: 'The house does not have a:',
    options: ['A second bedroom', 'A kitchen', 'A garden', 'A living room'],
    a: 'A garden',
  },
  {
    id: 'a1_r_13', level: 'A1', skill: 'reading', type: 'reading',
    passage: 'I work in a kitchen. I make bread and cakes every morning. I love my job.',
    q: "What is the speaker's job?",
    options: ['A teacher', 'A vet', 'A chef', 'A driver'],
    a: 'A chef',
  },
  {
    id: 'a1_r_14', level: 'A1', skill: 'reading', type: 'reading',
    passage: 'The store is open from Monday to Friday. It is closed on the weekend.',
    q: 'Can you go to the store on Saturday?',
    options: ['Yes, it opens at 9am', 'No, it is closed', 'Yes, but only in the morning', 'No, it opens on Sunday'],
    a: 'No, it is closed',
  },
  {
    id: 'a1_r_15', level: 'A1', skill: 'reading', type: 'reading',
    passage: 'I work inside a big office. I use a computer and I talk to people on the phone every day.',
    q: 'Where does the person work?',
    options: ['On a farm', 'Inside a building', 'At a school', 'Outside'],
    a: 'Inside a building',
  },
  {
    id: 'a1_r_16', level: 'A1', skill: 'reading', type: 'reading',
    passage: "To: Mom. Hi! I'm at the park with my dog, Rex. It is sunny today. See you at 5pm. Love, Sam.",
    q: 'Who is Rex?',
    options: ['A person', 'A cat', 'A dog', 'A brother'],
    a: 'A dog',
  },

  // ════════════════════════════════════════════════════════════
  // NIVEL A2 — Rutinas, Salud y Pasado Simple
  // 9 grammar · 9 vocabulary · 9 reading = 27 preguntas
  // ════════════════════════════════════════════════════════════

  // ── A2 GRAMMAR ───────────────────────────────────────────────
  {
    id: 'a2_g_01', level: 'A2', skill: 'grammar', type: 'mc',
    q: 'I usually drive, but today I ___ to work.',
    options: ['walk', 'walking', 'am walking', 'walked'],
    a: 'am walking',
  },
  {
    id: 'a2_g_02', level: 'A2', skill: 'grammar', type: 'mc',
    q: 'The Nile is ___ river in the world.',
    options: ['longer than', 'the longest', 'most long', 'long'],
    a: 'the longest',
  },
  {
    id: 'a2_g_05', level: 'A2', skill: 'grammar', type: 'mc',
    q: "___ turn right at the intersection; the bank is on the left.",
    options: ["Don't", 'Not', 'No', "Doesn't"],
    a: "Don't",
  },
  {
    id: 'a2_g_09', level: 'A2', skill: 'grammar', type: 'mc',
    q: 'I ___ to the cinema later today with my brother.',
    options: ['go', 'am going', 'goes', 'went'],
    a: 'am going',
  },
  {
    id: 'a2_g_10', level: 'A2', skill: 'grammar', type: 'mc',
    q: 'This tablet is ___ than that old laptop.',
    options: ['expensive', 'expensiver', 'more expensive', 'most expensive'],
    a: 'more expensive',
  },
  {
    id: 'a2_g_13', level: 'A2', skill: 'grammar', type: 'mc',
    q: 'We ___ to the beach last Sunday.',
    options: ['go', 'going', 'went', 'gone'],
    a: 'went',
  },
  {
    id: 'a2_g_14', level: 'A2', skill: 'grammar', type: 'mc',
    q: 'Did you ___ my email yesterday?',
    options: ['get', 'gets', 'got', 'getting'],
    a: 'get',
  },
  {
    id: 'a2_g_15', level: 'A2', skill: 'grammar', type: 'mc',
    q: 'How ___ milk do we have in the refrigerator?',
    options: ['many', 'much', 'some', 'any'],
    a: 'much',
  },
  {
    id: 'a2_g_16', level: 'A2', skill: 'grammar', type: 'mc',
    q: 'We ___ born in the same year.',
    options: ['was', 'were', 'did', 'are'],
    a: 'were',
  },

  // ── A2 VOCABULARY ────────────────────────────────────────────
  {
    id: 'a2_v_01', level: 'A2', skill: 'vocabulary', type: 'mc',
    q: 'I have a bad ___ in my tooth; I need a dentist.',
    options: ['broken', 'symptom', 'pain', 'cold'],
    a: 'pain',
  },
  {
    id: 'a2_v_02', level: 'A2', skill: 'vocabulary', type: 'mc',
    q: 'It is very ___ outside. I cannot see the road.',
    options: ['boiling', 'foggy', 'warm', 'dry'],
    a: 'foggy',
  },
  {
    id: 'a2_v_05', level: 'A2', skill: 'vocabulary', type: 'mc',
    q: 'I need to go to the ___ to buy some medicine.',
    options: ['library', 'pharmacy', 'factory', 'town hall'],
    a: 'pharmacy',
  },
  {
    id: 'a2_v_09', level: 'A2', skill: 'vocabulary', type: 'mc',
    q: 'It is very ___ today. It is 100°F outside!',
    options: ['freezing', 'boiling', 'chilly', 'foggy'],
    a: 'boiling',
  },
  {
    id: 'a2_v_10', level: 'A2', skill: 'vocabulary', type: 'mc',
    q: 'I need to ___ a doctor. I have had a fever for three days.',
    options: ['see', 'look', 'watch', 'find'],
    a: 'see',
  },
  {
    id: 'a2_v_13', level: 'A2', skill: 'vocabulary', type: 'mc',
    q: 'I have a ___ leg; I cannot walk to the park.',
    options: ['broken', 'swollen', 'injured', 'stiff'],
    a: 'broken',
  },
  {
    id: 'a2_v_14', level: 'A2', skill: 'vocabulary', type: 'mc',
    q: 'I missed the ___, so I had to take a taxi to the airport.',
    options: ['ticket', 'flight', 'platform', 'runway'],
    a: 'flight',
  },
  {
    id: 'a2_v_15', level: 'A2', skill: 'vocabulary', type: 'mc',
    q: "The car's ___ is making a strange noise; we should stop.",
    options: ['wheel', 'engine', 'trunk', 'headlight'],
    a: 'engine',
  },
  {
    id: 'a2_v_16', level: 'A2', skill: 'vocabulary', type: 'mc',
    q: 'It is very ___ today. Wear your boots and take an umbrella!',
    options: ['cloudy', 'windy', 'rainy', 'foggy'],
    a: 'rainy',
  },

  // ── A2 READING ───────────────────────────────────────────────
  {
    id: 'a2_r_01', level: 'A2', skill: 'reading', type: 'reading',
    passage: 'Last year, Mark went to Italy. He visited museums and ate pasta. He did not like the weather because it was too cold.',
    q: 'Why was the trip bad for Mark?',
    options: ['The food', 'The museums', 'The temperature', 'The price'],
    a: 'The temperature',
  },
  {
    id: 'a2_r_02', level: 'A2', skill: 'reading', type: 'reading',
    passage: "Dear Doctor, I have a backache and I feel sick. I cannot come to my appointment today.",
    q: 'What is the purpose of this note?',
    options: ['To ask for medicine', 'To cancel a meeting', 'To make an appointment', 'To describe symptoms'],
    a: 'To cancel a meeting',
  },
  {
    id: 'a2_r_05', level: 'A2', skill: 'reading', type: 'reading',
    passage: 'Take the first left, then go straight ahead for two blocks. The museum is opposite the park.',
    q: 'Where is the museum?',
    options: ['Next to the park', 'Behind the park', 'Across from the park', 'Near the library'],
    a: 'Across from the park',
  },
  {
    id: 'a2_r_09', level: 'A2', skill: 'reading', type: 'reading',
    passage: 'To make a salad: first, wash the vegetables. Then, chop the tomatoes and onions. Finally, add some oil and salt.',
    q: 'What is the last step?',
    options: ['Wash the vegetables', 'Chop the tomatoes', 'Add the onions', 'Add oil and salt'],
    a: 'Add oil and salt',
  },
  {
    id: 'a2_r_10', level: 'A2', skill: 'reading', type: 'reading',
    passage: 'The plane was late because of the fog. We arrived at the hotel at midnight, but the reception was still open.',
    q: 'Why was the plane late?',
    options: ['The pilot was late', 'Because of the weather', 'The hotel was full', 'It was too dark'],
    a: 'Because of the weather',
  },
  {
    id: 'a2_r_13', level: 'A2', skill: 'reading', type: 'reading',
    passage: 'The new hotel is beautiful. It is more expensive than the old hostel, but it is much quieter.',
    q: 'Which place is noisier?',
    options: ['The hotel', 'The hostel', 'Both are the same', 'Neither place'],
    a: 'The hostel',
  },
  {
    id: 'a2_r_14', level: 'A2', skill: 'reading', type: 'reading',
    passage: 'Instructions: First, wash your hands. Then, put the medicine on the cut. Finally, use a bandage.',
    q: 'What is the last step?',
    options: ['Wash your hands', 'Put medicine on the cut', 'Take a pill', 'Apply a bandage'],
    a: 'Apply a bandage',
  },
  {
    id: 'a2_r_15', level: 'A2', skill: 'reading', type: 'reading',
    passage: 'The train leaves at 8:15am. There is a café on platform 3 where you can buy breakfast before you board.',
    q: 'Where can you eat before the train?',
    options: ['On the train', 'On platform 3', 'At the station exit', 'In the waiting room'],
    a: 'On platform 3',
  },
  {
    id: 'a2_r_16', level: 'A2', skill: 'reading', type: 'reading',
    passage: 'First, put the bread in the toaster. Then, add some butter. Finally, eat it with your coffee.',
    q: 'What is the second step?',
    options: ['Put bread in the toaster', 'Use the butter', 'Drink the coffee', 'Boil some water'],
    a: 'Use the butter',
  },
  // ════════════════════════════════════════════════════════════
  // NIVEL B1 — Present Perfect, Phrasal Verbs y Trabajo
  // 10 grammar · 10 vocabulary · 10 reading = 30 preguntas
  // ════════════════════════════════════════════════════════════

  // ── B1 GRAMMAR ───────────────────────────────────────────────
  {
    id: 'b1_g_01', level: 'B1', skill: 'grammar', type: 'mc',
    q: 'I ___ learning English for three years now.',
    options: ['am', 'was', 'have been', 'did'],
    a: 'have been',
  },
  {
    id: 'b1_g_02', level: 'B1', skill: 'grammar', type: 'mc',
    q: 'I ___ finished the report, so you can read it now.',
    options: ['yet', 'already', 'still', 'ever'],
    a: 'already',
  },
  {
    id: 'b1_g_05', level: 'B1', skill: 'grammar', type: 'mc',
    q: 'He has worked for this company ___ 2015.',
    options: ['for', 'since', 'during', 'ago'],
    a: 'since',
  },
  {
    id: 'b1_g_09', level: 'B1', skill: 'grammar', type: 'mc',
    q: 'She ___ her house since she moved here last month.',
    options: ['redecorated', 'is redecorating', 'has been redecorating', 'redecorates'],
    a: 'has been redecorating',
  },
  {
    id: 'b1_g_10', level: 'B1', skill: 'grammar', type: 'mc',
    q: 'He ___ late for work, which makes the manager angry.',
    options: ['is often', 'often is', 'is always nearly', 'never is'],
    a: 'is often',
  },
  {
    id: 'b1_g_13', level: 'B1', skill: 'grammar', type: 'mc',
    q: 'I ___ my car all morning; that is why I am so dirty.',
    options: ['fixed', 'have fixed', 'have been fixing', 'am fixing'],
    a: 'have been fixing',
  },
  {
    id: 'b1_g_14', level: 'B1', skill: 'grammar', type: 'mc',
    q: 'You ___ smoke here; it is a hospital.',
    options: ["don't have to", "mustn't", "couldn't", "might not"],
    a: "mustn't",
  },
  {
    id: 'b1_g_15', level: 'B1', skill: 'grammar', type: 'mc',
    q: 'I ___ to Japan twice, and I want to go again next year.',
    options: ['have been', 'have gone', 'was going', 'went already'],
    a: 'have been',
  },
  {
    id: 'b1_g_16', level: 'B1', skill: 'grammar', type: 'mc',
    q: 'She can play the violin very ___.',
    options: ['good', 'better', 'well', 'best'],
    a: 'well',
  },
  {
    id: 'b1_g_17', level: 'B1', skill: 'grammar', type: 'mc',
    q: 'If it ___ tomorrow, we will cancel the trip.',
    options: ['rains', 'will rain', 'rained', 'is raining'],
    a: 'rains',
  },

  // ── B1 VOCABULARY ────────────────────────────────────────────
  {
    id: 'b1_v_01', level: 'B1', skill: 'vocabulary', type: 'mc',
    q: 'We had to ___ the meeting because the boss was sick.',
    options: ['put off', 'take up', 'grow up', 'turn up'],
    a: 'put off',
  },
  {
    id: 'b1_v_02', level: 'B1', skill: 'vocabulary', type: 'mc',
    q: 'I am looking for a ___ with a better salary.',
    options: ['work', 'job', 'task', 'career path'],
    a: 'job',
  },
  {
    id: 'b1_v_05', level: 'B1', skill: 'vocabulary', type: 'mc',
    q: 'I was very happy when my boss ___ me last month.',
    options: ['promoted', 'dismissed', 'recruited', 'transferred'],
    a: 'promoted',
  },
  {
    id: 'b1_v_09', level: 'B1', skill: 'vocabulary', type: 'mc',
    q: 'I am so tired. I think I will ___ tonight instead of going out.',
    options: ['turn up', 'stay in', 'chill out', 'meet up'],
    a: 'stay in',
  },
  {
    id: 'b1_v_10', level: 'B1', skill: 'vocabulary', type: 'mc',
    q: 'The company is looking for a ___ architect to lead the new project.',
    options: ['part-time', 'freelance', 'senior', 'retired'],
    a: 'freelance',
  },
  {
    id: 'b1_v_13', level: 'B1', skill: 'vocabulary', type: 'mc',
    q: 'It is important to ___ a good impression at an interview.',
    options: ['Do', 'Make', 'Take', 'Have'],
    a: 'Make',
  },
  {
    id: 'b1_v_14', level: 'B1', skill: 'vocabulary', type: 'mc',
    q: 'He decided to ___ from his job because the salary was too low.',
    options: ['promote', 'apply', 'resign', 'employ'],
    a: 'resign',
  },
  {
    id: 'b1_v_15', level: 'B1', skill: 'vocabulary', type: 'mc',
    q: 'I need to ___ the lawn because the grass is too long.',
    options: ['mow', 'clear', 'tidy', 'scrub'],
    a: 'mow',
  },
  {
    id: 'b1_v_16', level: 'B1', skill: 'vocabulary', type: 'mc',
    q: 'A ___ is a person who writes for a newspaper or website.',
    options: ['surgeon', 'journalist', 'plumber', 'architect'],
    a: 'journalist',
  },
  {
    id: 'b1_v_17', level: 'B1', skill: 'vocabulary', type: 'mc',
    q: 'I need to ___ up early tomorrow to catch the first train.',
    options: ['get', 'take', 'make', 'do'],
    a: 'get',
  },

  // ── B1 READING ───────────────────────────────────────────────
  {
    id: 'b1_r_01', level: 'B1', skill: 'reading', type: 'reading',
    passage: 'Remote work is popular. Many employees feel more productive at home, though some managers prefer office meetings.',
    q: 'What do some managers prefer?',
    options: ['Working from home', 'Face-to-face contact', 'Online meetings', 'Flexible hours'],
    a: 'Face-to-face contact',
  },
  {
    id: 'b1_r_02', level: 'B1', skill: 'reading', type: 'reading',
    passage: "I've been repairing faults in my apartment for years. It is expensive, but it is important to look after property.",
    q: 'The speaker believes that:',
    options: ['Repairs are cheap', 'Renting is better', 'Property needs care', 'Apartments are too small'],
    a: 'Property needs care',
  },
  {
    id: 'b1_r_05', level: 'B1', skill: 'reading', type: 'reading',
    passage: "I've been calculating how much money I've spent on repairs. Apartment maintenance is very expensive.",
    q: 'The speaker is worried about:',
    options: ['The age of the apartment', 'The cost of repairs', 'Finding a good plumber', 'Moving to a new place'],
    a: 'The cost of repairs',
  },
  {
    id: 'b1_r_09', level: 'B1', skill: 'reading', type: 'reading',
    passage: "I've always loved property. This week I have been viewing apartments with friends and calculating maintenance costs.",
    q: 'What has the speaker been doing recently?',
    options: ['Calculating repair costs', 'Looking at homes', 'Moving to a new city', 'Selling a property'],
    a: 'Looking at homes',
  },
  {
    id: 'b1_r_10', level: 'B1', skill: 'reading', type: 'reading',
    passage: 'Training nurses is a rewarding job. It takes years of experience, but helping people learn is the best thing in the world.',
    q: 'The speaker thinks their job is:',
    options: ['Difficult and stressful', 'Positive and satisfying', 'Boring but stable', 'Well-paid but lonely'],
    a: 'Positive and satisfying',
  },
  {
    id: 'b1_r_13', level: 'B1', skill: 'reading', type: 'reading',
    passage: "Tom has been learning to drive for six months. He has taken the test twice but has not passed yet. He is not giving up.",
    q: 'What is true about Tom?',
    options: ['He passed the test recently', 'He gave up driving', 'He has failed the test before', 'He just started learning'],
    a: 'He has failed the test before',
  },
  {
    id: 'b1_r_14', level: 'B1', skill: 'reading', type: 'reading',
    passage: "If the weather is bad tomorrow, we will have the party inside the house instead of in the garden.",
    q: 'Where will the party be if it rains?',
    options: ['In the garden', 'In the house', 'It will be canceled', 'At a restaurant'],
    a: 'In the house',
  },
  {
    id: 'b1_r_15', level: 'B1', skill: 'reading', type: 'reading',
    passage: 'Mark has been applying for jobs for three months. He has had four interviews but has not received an offer yet. He remains optimistic.',
    q: 'How does Mark feel about his job search?',
    options: ['Frustrated and angry', 'Confident and positive', 'Ready to give up', 'Indifferent about it'],
    a: 'Confident and positive',
  },
  {
    id: 'b1_r_16', level: 'B1', skill: 'reading', type: 'reading',
    passage: 'If you want to be a professional athlete, you could practice every day and find a good coach.',
    q: 'The text offers:',
    options: ['Instructions for beginners', 'Suggestions for success', 'Warnings about sport', 'Rules for competition'],
    a: 'Suggestions for success',
  },
  {
    id: 'b1_r_17', level: 'B1', skill: 'reading', type: 'reading',
    passage: "Anna has just started a new job at a marketing agency. She says it is challenging but she is learning a lot every day.",
    q: 'How does Anna feel about her new job?',
    options: ['Bored and unmotivated', 'Overwhelmed and quitting', 'Challenged but growing', 'Relaxed and comfortable'],
    a: 'Challenged but growing',
  },

  // ════════════════════════════════════════════════════════════
  // NIVEL B2 — Pasiva, Condicionales y Reporte
  // 10 grammar · 10 vocabulary · 10 reading = 30 preguntas
  // ════════════════════════════════════════════════════════════

  // ── B2 GRAMMAR ───────────────────────────────────────────────
  {
    id: 'b2_g_01', level: 'B2', skill: 'grammar', type: 'mc',
    q: 'He asked me ___ I had seen the new office layout.',
    options: ['that', 'weather', 'if', 'what'],
    a: 'if',
  },
  {
    id: 'b2_g_02', level: 'B2', skill: 'grammar', type: 'mc',
    q: 'The new stadium ___ by the end of next year.',
    options: ['will build', 'will be built', 'builds', 'is building'],
    a: 'will be built',
  },
  {
    id: 'b2_g_05', level: 'B2', skill: 'grammar', type: 'mc',
    q: 'You will fail the exam ___ you study much harder.',
    options: ['if', 'unless', 'whether', 'providing'],
    a: 'unless',
  },
  {
    id: 'b2_g_09', level: 'B2', skill: 'grammar', type: 'mc',
    q: 'The manager asked me ___ I was interested in a promotion.',
    options: ['that', 'if', 'what', 'for'],
    a: 'if',
  },
  {
    id: 'b2_g_10', level: 'B2', skill: 'grammar', type: 'mc',
    q: 'I wish I ___ more attention during the science lecture.',
    options: ['pay', 'paid', 'had paid', 'was paying'],
    a: 'had paid',
  },
  {
    id: 'b2_g_13', level: 'B2', skill: 'grammar', type: 'mc',
    q: 'The results of the experiment ___ tomorrow morning.',
    options: ['will announce', 'are announcing', 'will be announced', 'announced'],
    a: 'will be announced',
  },
  {
    id: 'b2_g_14', level: 'B2', skill: 'grammar', type: 'mc',
    q: 'She asked him where ___ his new car.',
    options: ['did he buy', 'he has bought', 'he had bought', 'bought he'],
    a: 'he had bought',
  },
  {
    id: 'b2_g_15', level: 'B2', skill: 'grammar', type: 'mc',
    q: 'If I ___ more money, I would travel around the world.',
    options: ['had', 'have', 'would have', 'will have'],
    a: 'had',
  },
  {
    id: 'b2_g_16', level: 'B2', skill: 'grammar', type: 'mc',
    q: 'The suspect admitted ___ the money from the office.',
    options: ['to steal', 'stealing', 'steal', 'that stolen'],
    a: 'stealing',
  },
  {
    id: 'b2_g_17', level: 'B2', skill: 'grammar', type: 'mc',
    q: 'It is time the government ___ action on climate change.',
    options: ['takes', 'took', 'has taken', 'will take'],
    a: 'took',
  },

  // ── B2 VOCABULARY ────────────────────────────────────────────
  {
    id: 'b2_v_01', level: 'B2', skill: 'vocabulary', type: 'mc',
    q: 'The city is quite ___; there is too much traffic and noise.',
    options: ['Bustling', 'Tranquil', 'Desolate', 'Barren'],
    a: 'Bustling',
  },
  {
    id: 'b2_v_02', level: 'B2', skill: 'vocabulary', type: 'mc',
    q: 'His reaction was ___; he screamed for no real reason.',
    options: ['over the top', 'a pinch of salt', 'cold feet', 'on the fence'],
    a: 'over the top',
  },
  {
    id: 'b2_v_05', level: 'B2', skill: 'vocabulary', type: 'mc',
    q: 'The old factory was ___ because it was no longer safe.',
    options: ['demolished', 'renovated', 'abandoned', 'evacuated'],
    a: 'demolished',
  },
  {
    id: 'b2_v_09', level: 'B2', skill: 'vocabulary', type: 'mc',
    q: 'The road was closed due to ___; there was water everywhere.',
    options: ['drought', 'flooding', 'sandstorm', 'heatwave'],
    a: 'flooding',
  },
  {
    id: 'b2_v_10', level: 'B2', skill: 'vocabulary', type: 'mc',
    q: 'I need to ___ the bed and do the laundry before the guests arrive.',
    options: ['do', 'make', 'clean', 'sweep'],
    a: 'make',
  },
  {
    id: 'b2_v_13', level: 'B2', skill: 'vocabulary', type: 'mc',
    q: 'We had to ___ the meeting until next week because of the storm.',
    options: ['cancel', 'postpone', 'hold', 'set'],
    a: 'postpone',
  },
  {
    id: 'b2_v_14', level: 'B2', skill: 'vocabulary', type: 'mc',
    q: 'I was so ___ when my favorite team lost the match.',
    options: ['amazed', 'thrilled', 'devastated', 'ecstatic'],
    a: 'devastated',
  },
  {
    id: 'b2_v_15', level: 'B2', skill: 'vocabulary', type: 'mc',
    q: 'We reached a ___ after discussing the plan for three hours.',
    options: ['consensus', 'discussion', 'agenda', 'minutes'],
    a: 'consensus',
  },
  {
    id: 'b2_v_16', level: 'B2', skill: 'vocabulary', type: 'mc',
    q: 'The house was ___; no one had lived there for fifty years.',
    options: ['derelict', 'picturesque', 'unspoiled', 'vibrant'],
    a: 'derelict',
  },
  {
    id: 'b2_v_17', level: 'B2', skill: 'vocabulary', type: 'mc',
    q: 'The new policy will ___ all employees, regardless of their position.',
    options: ['affect', 'effect', 'infect', 'reflect'],
    a: 'affect',
  },

  // ── B2 READING ───────────────────────────────────────────────
  {
    id: 'b2_r_01', level: 'B2', skill: 'reading', type: 'reading',
    passage: "If you want to feel calmer, slow your pace! Plan your day carefully and don't stay up late if you're tired.",
    q: 'The text suggests that calmness comes from:',
    options: ['Exercise', 'Organization', 'Sleeping more', 'Avoiding work'],
    a: 'Organization',
  },
  {
    id: 'b2_r_02', level: 'B2', skill: 'reading', type: 'reading',
    passage: 'Fez is a bizarre mix of the ancient and modern. The old part is intact, but the new city grows every day.',
    q: 'What is true about Fez?',
    options: ['It is fully modern', 'The old city was destroyed', 'It mixes two styles', 'It has no new buildings'],
    a: 'It mixes two styles',
  },
  {
    id: 'b2_r_05', level: 'B2', skill: 'reading', type: 'reading',
    passage: 'I wish I had studied more science at school. Now, I want to be a doctor but it is very difficult.',
    q: "What is the speaker's regret?",
    options: ['Not becoming a doctor sooner', 'Their choice of subjects', 'Not going to university', 'Studying medicine abroad'],
    a: 'Their choice of subjects',
  },
  {
    id: 'b2_r_09', level: 'B2', skill: 'reading', type: 'reading',
    passage: 'Notwithstanding the high price of the tickets, the concert was completely sold out within minutes of the announcement.',
    q: 'Were the tickets expensive?',
    options: ['No, people refused to buy them', 'Yes, but people bought them', 'No, they were free', 'Yes, and nobody bought them'],
    a: 'Yes, but people bought them',
  },
  {
    id: 'b2_r_10', level: 'B2', skill: 'reading', type: 'reading',
    passage: 'If you want to live a simpler life, you should consider downsizing. Move to a smaller home and give away your extra possessions.',
    q: 'What is a way to have a simpler life?',
    options: ['Buy a bigger house', 'Travel more often', 'Get rid of things', 'Work less hours'],
    a: 'Get rid of things',
  },
  {
    id: 'b2_r_13', level: 'B2', skill: 'reading', type: 'reading',
    passage: 'Notwithstanding the risks, the board decided to proceed with the merger to ensure long-term growth.',
    q: 'Why did they proceed?',
    options: ['They ignored the risks', 'To achieve future growth', 'Because it was cheap', 'The board was replaced'],
    a: 'To achieve future growth',
  },
  {
    id: 'b2_r_14', level: 'B2', skill: 'reading', type: 'reading',
    passage: 'Many cities are now introducing congestion charges to reduce the number of cars in the city centre and improve air quality.',
    q: 'What is the main goal of congestion charges?',
    options: ['Raise government taxes', 'Reduce traffic and pollution', 'Ban private vehicles', 'Improve public transport funding'],
    a: 'Reduce traffic and pollution',
  },
  {
    id: 'b2_r_15', level: 'B2', skill: 'reading', type: 'reading',
    passage: 'Urban farming is gaining popularity in cities worldwide. It reduces food miles, improves air quality, and creates community spaces in unused areas.',
    q: 'What is one benefit of urban farming mentioned?',
    options: ['It increases food prices', 'It reduces food transportation', 'It uses less water', 'It creates more traffic'],
    a: 'It reduces food transportation',
  },
  {
    id: 'b2_r_16', level: 'B2', skill: 'reading', type: 'reading',
    passage: 'If the board modernizes the factory, we will increase productivity and set a precedent for other stores.',
    q: 'What is the expected result of modernizing?',
    options: ['Lower costs immediately', 'Higher efficiency', 'Fewer employees needed', 'Better marketing'],
    a: 'Higher efficiency',
  },
  {
    id: 'b2_r_17', level: 'B2', skill: 'reading', type: 'reading',
    passage: 'Studies show that people who exercise regularly report lower stress levels, better sleep, and improved concentration at work.',
    q: 'According to the text, regular exercise leads to:',
    options: ['Higher salaries', 'Better physical appearance', 'Improved mental wellbeing', 'Stronger social bonds'],
    a: 'Improved mental wellbeing',
  },
  // ════════════════════════════════════════════════════════════
  // NIVEL C1 — Inversión, Condicionales Mixtos y Vocabulario Avanzado
  // 10 grammar · 10 vocabulary · 10 reading = 30 preguntas
  // ════════════════════════════════════════════════════════════

  // ── C1 GRAMMAR ───────────────────────────────────────────────
  {
    id: 'c1_g_01', level: 'C1', skill: 'grammar', type: 'mc',
    q: 'Scarcely ___ started the meeting when the power went out.',
    options: ['I had', 'had I', 'did I', 'I was'],
    a: 'had I',
  },
  {
    id: 'c1_g_02', level: 'C1', skill: 'grammar', type: 'mc',
    q: "I would rather you ___ talk about the budget in public.",
    options: ['not', "don't", "didn't", "won't"],
    a: "didn't",
  },
  {
    id: 'c1_g_05', level: 'C1', skill: 'grammar', type: 'mc',
    q: 'We hired a consultant ___ we could improve our market strategy.',
    options: ['in order to', 'so that', 'so as to', 'consequently'],
    a: 'so that',
  },
  {
    id: 'c1_g_09', level: 'C1', skill: 'grammar', type: 'mc',
    q: 'Only when she switched on the light ___ the extent of the mess.',
    options: ['she saw', 'did she see', 'she had seen', 'saw she'],
    a: 'did she see',
  },
  {
    id: 'c1_g_10', level: 'C1', skill: 'grammar', type: 'mc',
    q: "I don't think they will accept the terms, but I ___ so.",
    options: ['believe', 'expect', 'hope', 'wait'],
    a: 'hope',
  },
  {
    id: 'c1_g_13', level: 'C1', skill: 'grammar', type: 'mc',
    q: 'If I spoke Italian, I ___ for that job in Rome last year.',
    options: ['applied', 'would apply', 'would have applied', 'will apply'],
    a: 'would have applied',
  },
  {
    id: 'c1_g_14', level: 'C1', skill: 'grammar', type: 'mc',
    q: 'The city council requires that the park ___ open to the public at all times.',
    options: ['remains', 'remain', 'remaining', 'remained'],
    a: 'remain',
  },
  {
    id: 'c1_g_15', level: 'C1', skill: 'grammar', type: 'mc',
    q: 'By this time next year, I ___ in London for a decade.',
    options: ['will live', 'will be living', 'will have been living', 'am living'],
    a: 'will have been living',
  },
  {
    id: 'c1_g_16', level: 'C1', skill: 'grammar', type: 'mc',
    q: 'The documents ___ yesterday, but the courier was delayed.',
    options: ['should have sent', 'should be sent', 'should have been sent', 'sent'],
    a: 'should have been sent',
  },
  {
    id: 'c1_g_17', level: 'C1', skill: 'grammar', type: 'mc',
    q: 'Not only ___ the deadline, but they also exceeded all expectations.',
    options: ['they met', 'did they meet', 'they have met', 'met they'],
    a: 'did they meet',
  },

  // ── C1 VOCABULARY ────────────────────────────────────────────
  {
    id: 'c1_v_01', level: 'C1', skill: 'vocabulary', type: 'mc',
    q: 'The presentation was ___; it lacked substance and real data.',
    options: ['Rhetorical', 'Concise', 'Empirical', 'Analytical'],
    a: 'Rhetorical',
  },
  {
    id: 'c1_v_02', level: 'C1', skill: 'vocabulary', type: 'mc',
    q: 'We need to ___ the rules if we want to finish on time.',
    options: ['cut corners', 'face the music', 'let our hair down', 'get cold feet'],
    a: 'cut corners',
  },
  {
    id: 'c1_v_05', level: 'C1', skill: 'vocabulary', type: 'mc',
    q: 'The company decided to ___ the new rules to avoid further confusion.',
    options: ['circumvent', 'underscore', 'extrapolate', 'capitulate'],
    a: 'underscore',
  },
  {
    id: 'c1_v_09', level: 'C1', skill: 'vocabulary', type: 'mc',
    q: 'The scientist tried to ___ future trends based on the available data.',
    options: ['extrapolate', 'capitulate', 'relinquish', 'devour'],
    a: 'extrapolate',
  },
  {
    id: 'c1_v_10', level: 'C1', skill: 'vocabulary', type: 'mc',
    q: 'His ___ remarks during the meeting made everyone feel uncomfortable.',
    options: ['capacious', 'brusque', 'orthodox', 'vibrant'],
    a: 'brusque',
  },
  {
    id: 'c1_v_13', level: 'C1', skill: 'vocabulary', type: 'mc',
    q: 'I took what he said with a ___; he always exaggerates his achievements.',
    options: ['pinch of salt', 'cold feet', 'full swing', 'head in the clouds'],
    a: 'pinch of salt',
  },
  {
    id: 'c1_v_14', level: 'C1', skill: 'vocabulary', type: 'mc',
    q: 'The evidence was carefully ___ by the investigators before any charges were made.',
    options: ['exonerated', 'scrutinized', 'capitulated', 'relinquished'],
    a: 'scrutinized',
  },
  {
    id: 'c1_v_15', level: 'C1', skill: 'vocabulary', type: 'mc',
    q: 'His apology was ___ because he repeated the same mistake the next day.',
    options: ['hollow', 'capacious', 'vibrant', 'brusque'],
    a: 'hollow',
  },
  {
    id: 'c1_v_16', level: 'C1', skill: 'vocabulary', type: 'mc',
    q: 'The government decided to ___ the new tax regulations to help small businesses.',
    options: ['curb', 'repeal', 'exacerbate', 'extrapolate'],
    a: 'repeal',
  },
  {
    id: 'c1_v_17', level: 'C1', skill: 'vocabulary', type: 'mc',
    q: 'The committee was asked to ___ a solution before the end of the quarter.',
    options: ['devise', 'devour', 'defer', 'digress'],
    a: 'devise',
  },

  // ── C1 READING ───────────────────────────────────────────────
  {
    id: 'c1_r_01', level: 'C1', skill: 'reading', type: 'reading',
    passage: 'The paradox of choice suggests that an overabundance of options can lead to decision paralysis and decreased satisfaction.',
    q: 'According to the text, what is a risk of having many options?',
    options: ['Better decisions', 'Inability to decide', 'More satisfaction', 'Faster choices'],
    a: 'Inability to decide',
  },
  {
    id: 'c1_r_02', level: 'C1', skill: 'reading', type: 'reading',
    passage: "Neuroplasticity—the brain's ability to reorganize itself—challenges the belief that the adult brain is fixed.",
    q: 'The discovery of neuroplasticity implies that:',
    options: ['The brain stops developing at 25', 'Adults can still learn', 'Children always learn faster', 'Memory is permanent'],
    a: 'Adults can still learn',
  },
  {
    id: 'c1_r_05', level: 'C1', skill: 'reading', type: 'reading',
    passage: 'The gig economy offers flexibility but often lacks the security and benefits of traditional employment.',
    q: 'Critics of the gig economy emphasize:',
    options: ['The flexibility it offers', 'The lack of worker protection', 'The high income potential', 'The variety of tasks'],
    a: 'The lack of worker protection',
  },
  {
    id: 'c1_r_09', level: 'C1', skill: 'reading', type: 'reading',
    passage: 'Confirmation bias leads people to favour information that confirms their existing beliefs while ignoring contradictory evidence.',
    q: 'A person with confirmation bias tends to:',
    options: ['Seek opposing views', 'Ignore challenging information', 'Make rational decisions', 'Trust all sources equally'],
    a: 'Ignore challenging information',
  },
  {
    id: 'c1_r_10', level: 'C1', skill: 'reading', type: 'reading',
    passage: 'Automation is transforming industries at an unprecedented pace, raising concerns about structural unemployment and the need for workforce reskilling.',
    q: 'The main concern about automation is:',
    options: ['Lack of freedom', 'Permanent job losses', 'Lower productivity', 'Fixed contracts'],
    a: 'Permanent job losses',
  },
  {
    id: 'c1_r_13', level: 'C1', skill: 'reading', type: 'reading',
    passage: 'Cognitive dissonance arises when a person holds two conflicting beliefs simultaneously, causing psychological discomfort that motivates them to resolve the contradiction.',
    q: 'Cognitive dissonance is best described as:',
    options: ['A learning technique', 'Mental discomfort from conflicting beliefs', 'A form of memory loss', 'A decision-making strategy'],
    a: 'Mental discomfort from conflicting beliefs',
  },
  {
    id: 'c1_r_14', level: 'C1', skill: 'reading', type: 'reading',
    passage: 'Digital nomadism is frequently portrayed as ultimate freedom, yet it can be seen as a form of modern economic colonialism.',
    q: 'The text implies that digital nomadism:',
    options: ['Is purely positive', 'Causes global equality', 'Has hidden negative impacts', 'Is a temporary trend'],
    a: 'Has hidden negative impacts',
  },
  {
    id: 'c1_r_15', level: 'C1', skill: 'reading', type: 'reading',
    passage: 'The "floor effect" in testing occurs when a student is so far below the required level that they cannot answer any questions correctly.',
    q: 'The floor effect is problematic because:',
    options: ['It makes tests too easy', 'It gives no data on ability', 'It discourages weak students', 'It raises test anxiety'],
    a: 'It gives no data on ability',
  },
  {
    id: 'c1_r_16', level: 'C1', skill: 'reading', type: 'reading',
    passage: 'Sunk cost fallacy occurs when people continue investing in a failing project because of resources already committed, rather than evaluating future potential.',
    q: 'The sunk cost fallacy causes people to:',
    options: ['Make rational decisions', 'Focus on future gains', 'Persist due to past investment', 'Abandon projects early'],
    a: 'Persist due to past investment',
  },
  {
    id: 'c1_r_17', level: 'C1', skill: 'reading', type: 'reading',
    passage: 'Anchoring bias occurs when people rely too heavily on the first piece of information they encounter when making decisions.',
    q: 'Anchoring bias affects decision-making by:',
    options: ['Encouraging creative thinking', 'Overweighting initial information', 'Reducing cognitive load', 'Improving accuracy'],
    a: 'Overweighting initial information',
  },

  // ════════════════════════════════════════════════════════════
  // NIVEL C2 — Maestría: Precisión, Abstracción y Filosofía
  // 10 grammar · 10 vocabulary · 10 reading = 30 preguntas
  // ════════════════════════════════════════════════════════════

  // ── C2 GRAMMAR ───────────────────────────────────────────────
  {
    id: 'c2_g_01', level: 'C2', skill: 'grammar', type: 'mc',
    q: '___ the evidence been more compelling, the verdict might have changed.',
    options: ['Had', 'Were', 'Should', 'If'],
    a: 'Had',
  },
  {
    id: 'c2_g_02', level: 'C2', skill: 'grammar', type: 'mc',
    q: '___ being warned of the risks, the CEO proceeded with the merger.',
    options: ['Notwithstanding', 'Despite of', 'Although', 'However'],
    a: 'Notwithstanding',
  },
  {
    id: 'c2_g_05', level: 'C2', skill: 'grammar', type: 'mc',
    q: '___ it may seem counterintuitive, the evidence strongly supports this conclusion.',
    options: ['Be that as it may', 'Whatever', 'Even though', 'Whereas'],
    a: 'Be that as it may',
  },
  {
    id: 'c2_g_09', level: 'C2', skill: 'grammar', type: 'mc',
    q: '___ I known about the delays, I would have taken a different route.',
    options: ['Had', 'If', 'Were', 'Should'],
    a: 'Had',
  },
  {
    id: 'c2_g_10', level: 'C2', skill: 'grammar', type: 'mc',
    q: '___ unwell, she decided to leave the conference early.',
    options: ['Feeling', 'Having felt', 'To feel', 'Felt'],
    a: 'Feeling',
  },
  {
    id: 'c2_g_13', level: 'C2', skill: 'grammar', type: 'mc',
    q: 'Not until she switched on the light ___ the extent of the disaster.',
    options: ['she realized', 'did she realize', 'realized she', 'she had realized'],
    a: 'did she realize',
  },
  {
    id: 'c2_g_14', level: 'C2', skill: 'grammar', type: 'mc',
    q: 'The suspect claimed ___ something else entirely when the incident occurred.',
    options: ['to be doing', 'to do', 'doing', 'to have done'],
    a: 'to be doing',
  },
  {
    id: 'c2_g_15', level: 'C2', skill: 'grammar', type: 'mc',
    q: 'Rarely ___ such a compelling argument been presented in a courtroom.',
    options: ['has', 'had', 'was', 'did'],
    a: 'has',
  },
  {
    id: 'c2_g_16', level: 'C2', skill: 'grammar', type: 'mc',
    q: 'The findings, ___ they may be, suggest a fundamental flaw in the methodology.',
    options: ['tentative as', 'as tentative', 'however tentative', 'although tentative'],
    a: 'tentative as',
  },
  {
    id: 'c2_g_17', level: 'C2', skill: 'grammar', type: 'mc',
    q: '___ she to resign, the entire project would be at risk.',
    options: ['Were', 'Had', 'Should', 'Would'],
    a: 'Were',
  },

  // ── C2 VOCABULARY ────────────────────────────────────────────
  {
    id: 'c2_v_01', level: 'C2', skill: 'vocabulary', type: 'mc',
    q: 'Her ___ attitude made it impossible to have a polite discussion.',
    options: ['Acrimonious', 'Sanguine', 'Perfunctory', 'Magnanimous'],
    a: 'Acrimonious',
  },
  {
    id: 'c2_v_02', level: 'C2', skill: 'vocabulary', type: 'mc',
    q: 'The project was a ___ victory; they won, but lost all their money.',
    options: ['Pyrrhic', 'Hollow', 'Ephemeral', 'Bittersweet'],
    a: 'Pyrrhic',
  },
  {
    id: 'c2_v_05', level: 'C2', skill: 'vocabulary', type: 'mc',
    q: 'The negotiations reached an ___ when neither side would agree to the terms.',
    options: ['epiphany', 'impasse', 'accolade', 'anecdote'],
    a: 'impasse',
  },
  {
    id: 'c2_v_09', level: 'C2', skill: 'vocabulary', type: 'mc',
    q: "The politician's speech was filled with ___; it promised much but addressed no real issues.",
    options: ['bombast', 'candor', 'brevity', 'panacea'],
    a: 'bombast',
  },
  {
    id: 'c2_v_10', level: 'C2', skill: 'vocabulary', type: 'mc',
    q: 'His ___ nature made him change his plans three times in one afternoon.',
    options: ['capricious', 'steadfast', 'reticent', 'benevolent'],
    a: 'capricious',
  },
  {
    id: 'c2_v_13', level: 'C2', skill: 'vocabulary', type: 'mc',
    q: "The minister's calm response to the crisis was seen as ___, masking his true anxiety.",
    options: ['imperturbable', 'magnanimous', 'querulous', 'sycophantic'],
    a: 'imperturbable',
  },
  {
    id: 'c2_v_14', level: 'C2', skill: 'vocabulary', type: 'mc',
    q: 'His speech was described as ___; it was grand but lacked any real substance.',
    options: ['Bombastic', 'Laconic', 'Cogent', 'Pragmatic'],
    a: 'Bombastic',
  },
  {
    id: 'c2_v_15', level: 'C2', skill: 'vocabulary', type: 'mc',
    q: 'The merger was a ___ decision; it happened without any prior planning.',
    options: ['capricious', 'meticulous', 'scrupulous', 'circumspect'],
    a: 'capricious',
  },
  {
    id: 'c2_v_16', level: 'C2', skill: 'vocabulary', type: 'mc',
    q: "The CEO's resignation was the ___ of a year-long investigation into fraud.",
    options: ['culmination', 'pittance', 'serendipity', 'bombast'],
    a: 'culmination',
  },
  {
    id: 'c2_v_17', level: 'C2', skill: 'vocabulary', type: 'mc',
    q: 'The philosopher was known for his ___ style — every word chosen with surgical precision.',
    options: ['lapidary', 'verbose', 'turgid', 'effusive'],
    a: 'lapidary',
  },

  // ── C2 READING ───────────────────────────────────────────────
  {
    id: 'c2_r_01', level: 'C2', skill: 'reading', type: 'reading',
    passage: 'Testimonial injustice occurs when a speaker receives less credibility than they deserve due to identity prejudice.',
    q: 'Testimonial injustice is primarily a problem of:',
    options: ['Lack of facts', 'Identity bias', 'Poor speaking', 'Legal errors'],
    a: 'Identity bias',
  },
  {
    id: 'c2_r_02', level: 'C2', skill: 'reading', type: 'reading',
    passage: 'Post-structuralism posits that meaning is perpetually deferred and contingent on the interplay of signs.',
    q: 'In this theory, meaning is considered:',
    options: ['Fixed', 'Author-dependent', 'Never fully present', 'Inherent in words'],
    a: 'Never fully present',
  },
  {
    id: 'c2_r_05', level: 'C2', skill: 'reading', type: 'reading',
    passage: "Epistemic humility requires acknowledging the limits of one's knowledge, particularly in domains where certainty is unattainable.",
    q: 'Epistemic humility is best described as:',
    options: ["Knowing everything", "Accepting one's ignorance", 'Avoiding difficult topics', 'Trusting authority'],
    a: "Accepting one's ignorance",
  },
  {
    id: 'c2_r_09', level: 'C2', skill: 'reading', type: 'reading',
    passage: 'The Overton window describes the range of policies considered politically acceptable at any given time; ideas outside it are deemed radical.',
    q: 'An idea outside the Overton window would be seen as:',
    options: ['Mainstream', 'Politically extreme', 'Widely accepted', 'Historically relevant'],
    a: 'Politically extreme',
  },
  {
    id: 'c2_r_10', level: 'C2', skill: 'reading', type: 'reading',
    passage: 'The Sapir-Whorf hypothesis posits that the language one speaks fundamentally shapes the way one perceives and categorises reality.',
    q: 'According to the Sapir-Whorf hypothesis, language:',
    options: ['Is universal', 'Influences thought', 'Has no effect on perception', 'Is culturally neutral'],
    a: 'Influences thought',
  },
  {
    id: 'c2_r_13', level: 'C2', skill: 'reading', type: 'reading',
    passage: 'The concept of moral luck suggests that people are judged for outcomes that were largely outside their control, raising questions about the fairness of moral responsibility.',
    q: 'Moral luck challenges our assumptions about:',
    options: ['Legal systems', 'Fair judgment', 'Cultural norms', 'Personal ambition'],
    a: 'Fair judgment',
  },
  {
    id: 'c2_r_14', level: 'C2', skill: 'reading', type: 'reading',
    passage: 'The availability heuristic leads people to overestimate the likelihood of events that are easy to recall, often because they are dramatic or recent.',
    q: 'The availability heuristic causes people to:',
    options: ['Think more rationally', 'Misjudge probability based on memory', 'Ignore emotional responses', 'Rely on statistical data'],
    a: 'Misjudge probability based on memory',
  },
  {
    id: 'c2_r_15', level: 'C2', skill: 'reading', type: 'reading',
    passage: 'The Dunning-Kruger effect describes a cognitive bias whereby people with limited knowledge in a domain systematically overestimate their own competence.',
    q: 'The Dunning-Kruger effect involves:',
    options: ['Underestimating others', "Overestimating one's own ability", 'Refusing to learn new skills', 'Accurate self-assessment'],
    a: "Overestimating one's own ability",
  },
  {
    id: 'c2_r_16', level: 'C2', skill: 'reading', type: 'reading',
    passage: "Hanlon's Razor advises against attributing to malice what can be adequately explained by incompetence or negligence.",
    q: "Hanlon's Razor encourages people to:",
    options: ['Assume the worst of others', 'Interpret actions charitably', 'Avoid making judgments', 'Trust malicious intent'],
    a: 'Interpret actions charitably',
  },
  {
    id: 'c2_r_17', level: 'C2', skill: 'reading', type: 'reading',
    passage: "Occam's Razor is the principle that, among competing hypotheses, the one with the fewest assumptions should be selected.",
    q: "Occam's Razor favours:",
    options: ['The most complex explanation', 'The simplest explanation', 'The most popular theory', 'The oldest hypothesis'],
    a: 'The simplest explanation',
  },

  // ═══ LISTENING QUESTIONS (auto-generated) ════════════════
// ─────────────────────────────────────────────────────────────
// LISTENING SECTION — Placement Test Bank
// Auto-generated from placement_test_IMPROVED.json
// audio_id references the audio file to play (e.g. 'A1.1' → audio/placement/A1_1.mp3)
// skill: 'listening' | type: 'listening'
// Total questions: 76
// ─────────────────────────────────────────────────────────────

  // ════════════════════════════════════════════════════════════
  // A1 LISTENING — Daily Routines & Introductions
  // 11 listening questions across 3 audios
  // ════════════════════════════════════════════════════════════

  // ── Audio A1.1 ─────────────────────────────────────────────
  {
    id: 'a1_l_01', level: 'A1', skill: 'listening', type: 'listening',
    audio_id: 'A1.1',
    q: "When does Daniel's daily routine officially start?",
    options: ["At 7:00 AM", "At 8:00 AM, when he leaves for school", "In the afternoon, after school", "At night, after watching TV"],
    a: "At 7:00 AM",
  },
  {
    id: 'a1_l_02', level: 'A1', skill: 'listening', type: 'listening',
    audio_id: 'A1.1',
    q: "Where does he have his morning meal?",
    options: ["In the school cafeteria", "At his place of residence", "At a restaurant near home", "While playing soccer"],
    a: "At his place of residence",
  },
  {
    id: 'a1_l_03', level: 'A1', skill: 'listening', type: 'listening',
    audio_id: 'A1.1',
    q: "What is his main activity after his afternoon schedule?",
    options: ["Watching television shows", "Studying for his classes", "Participating in a sport", "Preparing breakfast"],
    a: "Participating in a sport",
  },
  // ── Audio A1.2 ─────────────────────────────────────────────
  {
    id: 'a1_l_04', level: 'A1', skill: 'listening', type: 'listening',
    audio_id: 'A1.2',
    q: "What is the name of the male speaker?",
    options: ["Daniel", "Alex", "Anna", "Ben"],
    a: "Ben",
  },
  {
    id: 'a1_l_05', level: 'A1', skill: 'listening', type: 'listening',
    audio_id: 'A1.2',
    q: "What country does the boy say he is from?",
    options: ["Canada", "Mexico", "The United States", "Spain"],
    a: "Canada",
  },
  {
    id: 'a1_l_06', level: 'A1', skill: 'listening', type: 'listening',
    audio_id: 'A1.2',
    q: "What is Anna's nationality?",
    options: ["Canadian", "Mexican", "Spanish", "American"],
    a: "Mexican",
  },
  {
    id: 'a1_l_07', level: 'A1', skill: 'listening', type: 'listening',
    audio_id: 'A1.2',
    q: "Are the speakers familiar with each other before this conversation?",
    options: ["Yes, they are old friends", "Yes, they studied together before", "No, they are meeting for the first time", "Maybe, but they do not remember"],
    a: "No, they are meeting for the first time",
  },
  // ── Audio A1.3 ─────────────────────────────────────────────
  {
    id: 'a1_l_08', level: 'A1', skill: 'listening', type: 'listening',
    audio_id: 'A1.3',
    q: "Who is the speaker introducing himself?",
    options: ["Ben", "A soccer coach", "A musician", "Alex"],
    a: "Alex",
  },
  {
    id: 'a1_l_09', level: 'A1', skill: 'listening', type: 'listening',
    audio_id: 'A1.3',
    q: "In what stage of life is the speaker?",
    options: ["His late teens", "His early twenties", "His childhood", "His early thirties"],
    a: "His late teens",
  },
  {
    id: 'a1_l_10', level: 'A1', skill: 'listening', type: 'listening',
    audio_id: 'A1.3',
    q: "What country does Alex mention as his place of origin?",
    options: ["Canada", "Mexico", "The United States", "Spain"],
    a: "Mexico",
  },
  {
    id: 'a1_l_11', level: 'A1', skill: 'listening', type: 'listening',
    audio_id: 'A1.3',
    q: "What does Alex do for leisure?",
    options: ["He works with his family", "He travels abroad", "He enjoys athletic and musical activities", "He studies history"],
    a: "He enjoys athletic and musical activities",
  },

  // ════════════════════════════════════════════════════════════
  // A2 LISTENING — Locations, Schedules & Conversations
  // 13 listening questions across 3 audios
  // ════════════════════════════════════════════════════════════

  // ── Audio A2.1 ─────────────────────────────────────────────
  {
    id: 'a2_l_01', level: 'A2', skill: 'listening', type: 'listening',
    audio_id: 'A2.1',
    q: "How is Lucas's current living environment described?",
    options: ["A non-urban area situated by the sea", "A busy city center", "A mountain village", "Near a large industrial area"],
    a: "A non-urban area situated by the sea",
  },
  {
    id: 'a2_l_02', level: 'A2', skill: 'listening', type: 'listening',
    audio_id: 'A2.1',
    q: "What is Lucas's professional role?",
    options: ["Serving tables at a beach resort", "Preparing food in a restaurant", "Walking dogs for tourists", "Managing a small hotel"],
    a: "Preparing food in a restaurant",
  },
  {
    id: 'a2_l_03', level: 'A2', skill: 'listening', type: 'listening',
    audio_id: 'A2.1',
    q: "What time does his work shift begin?",
    options: ["Early morning (7:00)", "On the weekends only", "Mid-morning (10:00)", "In the evening"],
    a: "Mid-morning (10:00)",
  },
  {
    id: 'a2_l_04', level: 'A2', skill: 'listening', type: 'listening',
    audio_id: 'A2.1',
    q: "How does he typically spend his time after his shift ends?",
    options: ["Cooking for his parents", "Watching movies with coworkers", "Visiting a nearby restaurant", "Taking a stroll along the shore with a pet"],
    a: "Taking a stroll along the shore with a pet",
  },
  {
    id: 'a2_l_05', level: 'A2', skill: 'listening', type: 'listening',
    audio_id: 'A2.1',
    q: "Which activity is part of his weekend routine?",
    options: ["Socializing with family or peers", "Working extra hours as a cook", "Walking on the beach alone", "Training his dog"],
    a: "Socializing with family or peers",
  },
  // ── Audio A2.2 ─────────────────────────────────────────────
  {
    id: 'a2_l_06', level: 'A2', skill: 'listening', type: 'listening',
    audio_id: 'A2.2',
    q: "What is the man's specific area of work?",
    options: ["Personal training in the gym", "Customer reception and assistance", "Maintenance on the second floor", "Security at the entrance"],
    a: "Customer reception and assistance",
  },
  {
    id: 'a2_l_07', level: 'A2', skill: 'listening', type: 'listening',
    audio_id: 'A2.2',
    q: "What instructions are given regarding the location of the fitness area?",
    options: ["It is in a separate building", "It is right behind the front desk", "It is situated one level above the ground floor", "It is on the ground floor"],
    a: "It is situated one level above the ground floor",
  },
  {
    id: 'a2_l_08', level: 'A2', skill: 'listening', type: 'listening',
    audio_id: 'A2.2',
    q: "When does the facility stop operating for the day?",
    options: ["At 9:00 in the morning", "At midnight", "In the late afternoon", "At 21:00"],
    a: "At 21:00",
  },
  {
    id: 'a2_l_09', level: 'A2', skill: 'listening', type: 'listening',
    audio_id: 'A2.2',
    q: "What is Sofia's ultimate objective in the building?",
    options: ["To engage in physical exercise", "To find a job at the front desk", "To meet with a personal trainer", "To ask for a tour of the second floor"],
    a: "To engage in physical exercise",
  },
  // ── Audio A2.3 ─────────────────────────────────────────────
  {
    id: 'a2_l_10', level: 'A2', skill: 'listening', type: 'listening',
    audio_id: 'A2.3',
    q: "When does the academic day start for the speaker?",
    options: ["At 7:00 AM, at the same time as breakfast", "At 8:00 AM", "After he finishes his homework", "In the afternoon with his friends"],
    a: "At 8:00 AM",
  },
  {
    id: 'a2_l_11', level: 'A2', skill: 'listening', type: 'listening',
    audio_id: 'A2.3',
    q: "At what hour does the speaker have his first meal of the day?",
    options: ["At eight, right before school", "After finishing his homework", "At seven in the morning", "During the school break"],
    a: "At seven in the morning",
  },
  {
    id: 'a2_l_12', level: 'A2', skill: 'listening', type: 'listening',
    audio_id: 'A2.3',
    q: "What is the sequence of events after classes end?",
    options: ["Eating breakfast and going to school", "Playing with friends before doing homework", "Meeting with teachers for extra lessons", "Returning home to study before leisure time"],
    a: "Returning home to study before leisure time",
  },
  {
    id: 'a2_l_13', level: 'A2', skill: 'listening', type: 'listening',
    audio_id: 'A2.3',
    q: "What is the speaker's opinion of the faculty?",
    options: ["She finds them to be pleasant and helpful", "She thinks they are too strict", "She believes they give too much homework", "She thinks they are very new to the school"],
    a: "She finds them to be pleasant and helpful",
  },

  // ════════════════════════════════════════════════════════════
  // B1 LISTENING — Narratives & Opinions
  // 13 listening questions across 3 audios
  // ════════════════════════════════════════════════════════════

  // ── Audio B1.1 ─────────────────────────────────────────────
  {
    id: 'b1_l_01', level: 'B1', skill: 'listening', type: 'listening',
    audio_id: 'B1.1',
    q: "What does Laura's professional life revolve around?",
    options: ["Assisting international travelers in exploring the city", "Teaching history in local schools", "Writing stories about foreign countries", "Managing a summer tourism agency"],
    a: "Assisting international travelers in exploring the city",
  },
  {
    id: 'b1_l_02', level: 'B1', skill: 'listening', type: 'listening',
    audio_id: 'B1.1',
    q: "Why does Laura find fulfillment in her career?",
    options: ["The high salary she earns during summer", "The opportunity for social interaction and historical narration", "The fact that she never finds it exhausting", "The opportunity to discover new places by herself"],
    a: "The opportunity for social interaction and historical narration",
  },
  {
    id: 'b1_l_03', level: 'B1', skill: 'listening', type: 'listening',
    audio_id: 'B1.1',
    q: "Under what circumstances does her job become more demanding?",
    options: ["When she has to travel to other countries", "During the winter months", "When there is a high volume of seasonal visitors", "When visitors are not interested in history"],
    a: "When there is a high volume of seasonal visitors",
  },
  {
    id: 'b1_l_04', level: 'B1', skill: 'listening', type: 'listening',
    audio_id: 'B1.1',
    q: "What is particularly rewarding for Laura regarding her clients?",
    options: ["Learning about their personal stories", "Receiving monetary tips at the end of tours", "Having the most tourists during the summer", "Witnessing their reaction to first-time discoveries"],
    a: "Witnessing their reaction to first-time discoveries",
  },
  // ── Audio B1.2 ─────────────────────────────────────────────
  {
    id: 'b1_l_05', level: 'B1', skill: 'listening', type: 'listening',
    audio_id: 'B1.2',
    q: "What was the nature of Daniel's weekend activity?",
    options: ["An outdoor excursion in a mountainous region", "A photography workshop in the city", "A lunch date at a city lake", "A solo trip to the mountains"],
    a: "An outdoor excursion in a mountainous region",
  },
  {
    id: 'b1_l_06', level: 'B1', skill: 'listening', type: 'listening',
    audio_id: 'B1.2',
    q: "How accessible was the destination from the city?",
    options: ["It required a long car journey of several hours", "A relatively short drive of sixty minutes", "It was within walking distance", "It was far enough to require a hotel stay"],
    a: "A relatively short drive of sixty minutes",
  },
  {
    id: 'b1_l_07', level: 'B1', skill: 'listening', type: 'listening',
    audio_id: 'B1.2',
    q: "What did the group do besides walking along the trail?",
    options: ["Went swimming in the small lake", "Climbed to the highest peak", "Documented the scenery and shared a meal", "Studied the local nature and wildlife"],
    a: "Documented the scenery and shared a meal",
  },
  {
    id: 'b1_l_08', level: 'B1', skill: 'listening', type: 'listening',
    audio_id: 'B1.2',
    q: "What is the primary psychological benefit Daniel gets from this hobby?",
    options: ["Physical training for his daily work", "The opportunity to practice photography professionally", "Socializing with new people every month", "Stress relief and environmental appreciation"],
    a: "Stress relief and environmental appreciation",
  },
  // ── Audio B1.3 ─────────────────────────────────────────────
  {
    id: 'b1_l_09', level: 'B1', skill: 'listening', type: 'listening',
    audio_id: 'B1.3',
    q: "What was the speaker's motivation for the trip?",
    options: ["The desire to explore an unfamiliar activity", "To visit a friend who had recently moved to the area", "To attend a local cultural festival", "To eat at a famous local restaurant"],
    a: "The desire to explore an unfamiliar activity",
  },
  {
    id: 'b1_l_10', level: 'B1', skill: 'listening', type: 'listening',
    audio_id: 'B1.3',
    q: "What type of place did the group visit?",
    options: ["A busy coastal city with beaches", "A peaceful small town near a mountain range", "A remote hiking trail with no town nearby", "A large mountain peak with extreme weather"],
    a: "A peaceful small town near a mountain range",
  },
  {
    id: 'b1_l_11', level: 'B1', skill: 'listening', type: 'listening',
    audio_id: 'B1.3',
    q: "Who comprised the traveling party?",
    options: ["The narrator and his family", "The narrator and one close friend", "The narrator and a small group of peers", "The narrator traveled alone"],
    a: "The narrator and a small group of peers",
  },
  {
    id: 'b1_l_12', level: 'B1', skill: 'listening', type: 'listening',
    audio_id: 'B1.3',
    q: "How is the atmosphere of the town described?",
    options: ["Busy and full of tourists", "Cold and difficult to access", "Warm but crowded with locals", "Serene and visually appealing"],
    a: "Serene and visually appealing",
  },
  {
    id: 'b1_l_13', level: 'B1', skill: 'listening', type: 'listening',
    audio_id: 'B1.3',
    q: "What was the highlight of the trip for the narrator?",
    options: ["The chance to unwind in a natural setting", "The quality of the local food", "Taking professional-grade photographs", "Learning about the town's history"],
    a: "The chance to unwind in a natural setting",
  },

  // ════════════════════════════════════════════════════════════
  // B2 LISTENING — Monologues on Society & Language
  // 13 listening questions across 3 audios
  // ════════════════════════════════════════════════════════════

  // ── Audio B2.1 ─────────────────────────────────────────────
  {
    id: 'b2_l_01', level: 'B2', skill: 'listening', type: 'listening',
    audio_id: 'B2.1',
    q: "What is the speaker's critique of traditional language study?",
    options: ["It overemphasizes theoretical knowledge over practical use", "It focuses too much on listening to podcasts", "It is only effective for native speakers", "It leads to faster progress than speaking"],
    a: "It overemphasizes theoretical knowledge over practical use",
  },
  {
    id: 'b2_l_02', level: 'B2', skill: 'listening', type: 'listening',
    audio_id: 'B2.1',
    q: "What is presented as the most vital element for language success?",
    options: ["Memorizing a vast amount of vocabulary", "Active engagement in genuine communicative situations", "Understanding the deep history of the language", "Studying grammar rules in a classroom setting"],
    a: "Active engagement in genuine communicative situations",
  },
  {
    id: 'b2_l_03', level: 'B2', skill: 'listening', type: 'listening',
    audio_id: 'B2.1',
    q: "How does the speaker suggest learners bridge the gap to real-world usage?",
    options: ["By following strict grammar textbooks", "By avoiding challenging situations at first", "By utilizing authentic audio resources and native interaction", "By focusing on writing rather than speaking"],
    a: "By utilizing authentic audio resources and native interaction",
  },
  {
    id: 'b2_l_04', level: 'B2', skill: 'listening', type: 'listening',
    audio_id: 'B2.1',
    q: "Why might learners initially find this approach uncomfortable?",
    options: ["Because native speakers speak too quickly to follow", "Because podcasts are rarely available for free", "Because grammar rules are harder to remember in context", "Because it exposes them to language as it is genuinely used, not as taught in theory"],
    a: "Because it exposes them to language as it is genuinely used, not as taught in theory",
  },
  {
    id: 'b2_l_05', level: 'B2', skill: 'listening', type: 'listening',
    audio_id: 'B2.1',
    q: "What is the eventual outcome of overcoming the initial difficulty of this method?",
    options: ["Enhanced self-assurance and accelerated development", "Complete mastery of complex grammar", "The ability to teach the language to others", "A decrease in the need for regular practice"],
    a: "Enhanced self-assurance and accelerated development",
  },
  // ── Audio B2.2 ─────────────────────────────────────────────
  {
    id: 'b2_l_06', level: 'B2', skill: 'listening', type: 'listening',
    audio_id: 'B2.2',
    q: "What shift in corporate perception is discussed?",
    options: ["The idea that all jobs can now be done from home", "The realization that physical presence is not tied to performance", "The need for more employees in the hospitality sector", "The belief that remote work reduces productivity"],
    a: "The realization that physical presence is not tied to performance",
  },
  {
    id: 'b2_l_07', level: 'B2', skill: 'listening', type: 'listening',
    audio_id: 'B2.2',
    q: "Why is remote work not a universal solution?",
    options: ["Because some employees lack digital skills", "Because online communication is always unreliable", "Certain industries require physical interaction with clients", "Because companies want to save on office space"],
    a: "Certain industries require physical interaction with clients",
  },
  {
    id: 'b2_l_08', level: 'B2', skill: 'listening', type: 'listening',
    audio_id: 'B2.2',
    q: "What is a major administrative hurdle in remote work?",
    options: ["The cost of internet access for all employees", "The lack of trust between managers and workers", "Finding enough time for personal lives", "Maintaining structured coordination across different locations"],
    a: "Maintaining structured coordination across different locations",
  },
  {
    id: 'b2_l_09', level: 'B2', skill: 'listening', type: 'listening',
    audio_id: 'B2.2',
    q: "What personal advantage does the man attribute to working from home?",
    options: ["The capacity to better integrate work with personal responsibilities", "A reduction in total working hours per week", "The ability to work multiple jobs simultaneously", "Less need for clear schedules and organization"],
    a: "The capacity to better integrate work with personal responsibilities",
  },
  // ── Audio B2.3 ─────────────────────────────────────────────
  {
    id: 'b2_l_10', level: 'B2', skill: 'listening', type: 'listening',
    audio_id: 'B2.3',
    q: "What societal trend is the speaker highlighting?",
    options: ["A decrease in the importance of office work", "An increased focus on personal well-being alongside professional duties", "The rise of flexible hours mandated by law", "The elimination of high-stress jobs"],
    a: "An increased focus on personal well-being alongside professional duties",
  },
  {
    id: 'b2_l_11', level: 'B2', skill: 'listening', type: 'listening',
    audio_id: 'B2.3',
    q: "How are employees changing their approach to their work life?",
    options: ["By working more hours to finish tasks early", "By prioritizing family over any work commitment", "By being more deliberate in their time management", "By refusing to work in physical offices"],
    a: "By being more deliberate in their time management",
  },
  {
    id: 'b2_l_12', level: 'B2', skill: 'listening', type: 'listening',
    audio_id: 'B2.3',
    q: "From a corporate perspective, why is work-life balance beneficial?",
    options: ["It allows companies to pay lower salaries", "It reduces the need for middle management", "It attracts younger, more tech-savvy workers", "Reduced stress levels correlate with higher output"],
    a: "Reduced stress levels correlate with higher output",
  },
  {
    id: 'b2_l_13', level: 'B2', skill: 'listening', type: 'listening',
    audio_id: 'B2.3',
    q: "What has become a strategic priority for modern organizations?",
    options: ["Cultivating a sustainable equilibrium for their workforce", "Increasing total office hours for better control", "Encouraging employees to focus solely on personal interests", "Eliminating the boundary between work and home"],
    a: "Cultivating a sustainable equilibrium for their workforce",
  },

  // ════════════════════════════════════════════════════════════
  // C1 LISTENING — Technology, Media & Education
  // 14 listening questions across 3 audios
  // ════════════════════════════════════════════════════════════

  // ── Audio C1.1 ─────────────────────────────────────────────
  {
    id: 'c1_l_01', level: 'C1', skill: 'listening', type: 'listening',
    audio_id: 'C1.1',
    q: "What has been the primary catalyst for the change in language acquisition?",
    options: ["The integration of digital resources and platforms", "The decline of traditional classroom methodology", "The shift toward native-only instruction", "The globalization of social communities"],
    a: "The integration of digital resources and platforms",
  },
  {
    id: 'c1_l_02', level: 'C1', skill: 'listening', type: 'listening',
    audio_id: 'C1.1',
    q: "Which specific resources does the speaker reference as examples of digital learning tools?",
    options: ["Video call platforms and translation software", "Language applications, virtual communities, and audio programs", "Television series and online dictionaries", "Search engines and academic databases"],
    a: "Language applications, virtual communities, and audio programs",
  },
  {
    id: 'c1_l_03', level: 'C1', skill: 'listening', type: 'listening',
    audio_id: 'C1.1',
    q: "What is a key benefit of using these digital tools?",
    options: ["The automation of the learning process", "The elimination of the need for discipline", "Increased contact with unfiltered, natural language", "The ability to bypass traditional grammar study"],
    a: "Increased contact with unfiltered, natural language",
  },
  {
    id: 'c1_l_04', level: 'C1', skill: 'listening', type: 'listening',
    audio_id: 'C1.1',
    q: "What does the speaker argue is a limitation of technology alone?",
    options: ["It is often less accurate than a human teacher", "It lacks enough authentic content for advanced levels", "It does not provide enough listening practice", "It cannot substitute for the learner's internal drive and consistency"],
    a: "It cannot substitute for the learner's internal drive and consistency",
  },
  {
    id: 'c1_l_05', level: 'C1', skill: 'listening', type: 'listening',
    audio_id: 'C1.1',
    q: "According to the passage, real fluency is the result of:",
    options: ["Technology combined with psychological commitment", "Purely digital immersion without formal study", "Replacing classrooms with online communities", "Following the latest trends in language apps"],
    a: "Technology combined with psychological commitment",
  },
  // ── Audio C1.2 ─────────────────────────────────────────────
  {
    id: 'c1_l_06', level: 'C1', skill: 'listening', type: 'listening',
    audio_id: 'C1.2',
    q: "What phenomenon regarding modern belief systems is being analyzed?",
    options: ["The technical improvement of recommendation systems", "The reinforcement of existing biases through social media structures", "The speed at which news is reported globally", "The decline of public interest in political debates"],
    a: "The reinforcement of existing biases through social media structures",
  },
  {
    id: 'c1_l_07', level: 'C1', skill: 'listening', type: 'listening',
    audio_id: 'C1.2',
    q: "How do algorithms contribute to 'echo chambers'?",
    options: ["By censoring opposing viewpoints from the public", "By forcing users to engage with controversial content", "By selectively presenting information that aligns with user preferences", "By prioritizing commercial content over social issues"],
    a: "By selectively presenting information that aligns with user preferences",
  },
  {
    id: 'c1_l_08', level: 'C1', skill: 'listening', type: 'listening',
    audio_id: 'C1.2',
    q: "What is the societal consequence of a lack of exposure to differing views?",
    options: ["A loss of interest in social media platforms", "The spread of unverified information online", "A decrease in the quality of online communication", "A deepening of ideological divisions within society"],
    a: "A deepening of ideological divisions within society",
  },
  {
    id: 'c1_l_09', level: 'C1', skill: 'listening', type: 'listening',
    audio_id: 'C1.2',
    q: "In what way can social media be considered a democratic tool?",
    options: ["By providing a platform for marginalized groups", "By ensuring all information is fact-checked before posting", "By allowing everyone to vote on public issues", "By reducing the influence of political algorithms"],
    a: "By providing a platform for marginalized groups",
  },
  // ── Audio C1.3 ─────────────────────────────────────────────
  {
    id: 'c1_l_10', level: 'C1', skill: 'listening', type: 'listening',
    audio_id: 'C1.3',
    q: "How has the paradigm of skill acquisition shifted?",
    options: ["From practical training to theoretical academic study", "From institutional dependency to self-directed digital learning", "From global communities to local school networks", "From free information to expensive formal programs"],
    a: "From institutional dependency to self-directed digital learning",
  },
  {
    id: 'c1_l_11', level: 'C1', skill: 'listening', type: 'listening',
    audio_id: 'C1.3',
    q: "Which modern resources does the speaker specifically mention for skill development?",
    options: ["Certified university programs and academic journals", "Search engines and digital encyclopedias", "Online platforms, instructional videos, and virtual learning communities", "Television documentaries and audio courses"],
    a: "Online platforms, instructional videos, and virtual learning communities",
  },
  {
    id: 'c1_l_12', level: 'C1', skill: 'listening', type: 'listening',
    audio_id: 'C1.3',
    q: "What specific advantage does this modern approach to learning provide?",
    options: ["The guarantee of obtaining a recognized academic degree", "Live interaction with certified professional instructors", "A structured curriculum validated by institutions", "The freedom to study at one's own rhythm and from virtually any location"],
    a: "The freedom to study at one's own rhythm and from virtually any location",
  },
  {
    id: 'c1_l_13', level: 'C1', skill: 'listening', type: 'listening',
    audio_id: 'C1.3',
    q: "What is the 'double-edged sword' of increased information access?",
    options: ["Availability does not equate to a profound grasp of the subject", "Digital communities are often less accurate than books", "Learning at one's own pace can lead to procrastination", "Too much information can discourage new learners"],
    a: "Availability does not equate to a profound grasp of the subject",
  },
  {
    id: 'c1_l_14', level: 'C1', skill: 'listening', type: 'listening',
    audio_id: 'C1.3',
    q: "What does the speaker define as the foundation of 'meaningful learning'?",
    options: ["The use of high-quality video tutorials exclusively", "The intersection of inquisitiveness, practice, and analytical evaluation", "Access to prestigious online certification platforms", "Formal recognition from accredited institutions"],
    a: "The intersection of inquisitiveness, practice, and analytical evaluation",
  },

  // ════════════════════════════════════════════════════════════
  // C2 LISTENING — Philosophy, Language Mastery & Critical Thought
  // 12 listening questions across 3 audios
  // ════════════════════════════════════════════════════════════

  // ── Audio C2.1 ─────────────────────────────────────────────
  {
    id: 'c2_l_01', level: 'C2', skill: 'listening', type: 'listening',
    audio_id: 'C2.1',
    q: "How does the speaker challenge the standard view of language mastery?",
    options: ["By asserting that technical proficiency is secondary to socio-cultural intuition", "By suggesting that native-level fluency is an impossible goal", "By emphasizing that vocabulary size is the true metric of success", "By claiming that grammar is more important than cultural context"],
    a: "By asserting that technical proficiency is secondary to socio-cultural intuition",
  },
  {
    id: 'c2_l_02', level: 'C2', skill: 'listening', type: 'listening',
    audio_id: 'C2.1',
    q: "What does 'understanding irony and humor' signify in this context?",
    options: ["The skill to translate jokes between different languages", "The ability to decode layers of meaning beyond literal words", "A high level of intelligence and social popularity", "The mastery of informal and slang expressions"],
    a: "The ability to decode layers of meaning beyond literal words",
  },
  {
    id: 'c2_l_03', level: 'C2', skill: 'listening', type: 'listening',
    audio_id: 'C2.1',
    q: "The mention of formal vs. informal disagreement highlights:",
    options: ["The difficulty of expressing anger in a second language", "The strict rules of etiquette in professional settings", "The importance of pragmatic flexibility in communication", "The difference between written and spoken language"],
    a: "The importance of pragmatic flexibility in communication",
  },
  {
    id: 'c2_l_04', level: 'C2', skill: 'listening', type: 'listening',
    audio_id: 'C2.1',
    q: "What is the speaker's final requirement for achieving a near-native level?",
    options: ["A complete absence of a foreign accent", "The ability to speak without any pauses or errors", "Extensive knowledge of a country's historical timeline", "The capacity to interpret the 'unsaid' within a cultural framework"],
    a: "The capacity to interpret the 'unsaid' within a cultural framework",
  },
  // ── Audio C2.2 ─────────────────────────────────────────────
  {
    id: 'c2_l_05', level: 'C2', skill: 'listening', type: 'listening',
    audio_id: 'C2.2',
    q: "What is the core philosophical inquiry of the dialogue?",
    options: ["Whether technical efficiency facilitates or hinders collective wisdom", "The impact of high-speed communication on education systems", "The role of specialized research in modern universities", "How technology has resolved the problem of human judgment"],
    a: "Whether technical efficiency facilitates or hinders collective wisdom",
  },
  {
    id: 'c2_l_06', level: 'C2', skill: 'listening', type: 'listening',
    audio_id: 'C2.2',
    q: "What is the 'pitfall' of rapid information dissemination according to the woman?",
    options: ["The control of information by large tech corporations", "The sacrifice of accuracy for the sake of immediacy", "The digital divide between different social classes", "The replacement of human judgment by algorithms"],
    a: "The sacrifice of accuracy for the sake of immediacy",
  },
  {
    id: 'c2_l_07', level: 'C2', skill: 'listening', type: 'listening',
    audio_id: 'C2.2',
    q: "How has technology affected the 'democratization of knowledge'?",
    options: ["It has made university degrees completely obsolete", "It has ensured that all information online is verified", "It has dismantled traditional barriers to specialized information", "It has eliminated the need for experts and researchers"],
    a: "It has dismantled traditional barriers to specialized information",
  },
  {
    id: 'c2_l_08', level: 'C2', skill: 'listening', type: 'listening',
    audio_id: 'C2.2',
    q: "What is the speakers' ultimate conclusion regarding progress?",
    options: ["Technology will eventually lead to a wiser society on its own", "Efficiency is the most important goal of modern innovation", "Critical thinking is becoming less necessary due to information access", "Wisdom is not a byproduct of technology, but of educational depth"],
    a: "Wisdom is not a byproduct of technology, but of educational depth",
  },
  // ── Audio C2.3 ─────────────────────────────────────────────
  {
    id: 'c2_l_09', level: 'C2', skill: 'listening', type: 'listening',
    audio_id: 'C2.3',
    q: "What misconception about the relationship between data and decision-making is addressed?",
    options: ["The fallacy that a high volume of information correlates with better judgment", "The idea that history is a reliable predictor of the future", "The belief that narratives are more important than evidence", "The assumption that persuasive stories are always unreliable"],
    a: "The fallacy that a high volume of information correlates with better judgment",
  },
  {
    id: 'c2_l_10', level: 'C2', skill: 'listening', type: 'listening',
    audio_id: 'C2.3',
    q: "Why is 'intellectual discipline' more necessary now than in the past?",
    options: ["Because information is more technically complex today", "To counteract the impulsive consumption of instantaneous information", "To help individuals memorize the vast amount of new content", "Because societies no longer value formal education"],
    a: "To counteract the impulsive consumption of instantaneous information",
  },
  {
    id: 'c2_l_11', level: 'C2', skill: 'listening', type: 'listening',
    audio_id: 'C2.3',
    q: "What creates the 'illusion of being informed'?",
    options: ["The ability to access restricted or specialized information", "The use of persuasive narratives by media outlets", "The continuous stream of new data, which is mistaken for understanding", "The speed at which one can share content with others"],
    a: "The continuous stream of new data, which is mistaken for understanding",
  },
  {
    id: 'c2_l_12', level: 'C2', skill: 'listening', type: 'listening',
    audio_id: 'C2.3',
    q: "According to the speaker, where does true understanding originate?",
    options: ["In the accumulation of diverse fragments of knowledge", "In the speed at which we can analyze complex data", "In the ability to find the most reliable evidence instantly", "In the rigorous scrutiny and questioning of available information"],
    a: "In the rigorous scrutiny and questioning of available information",
  },

];

// Utilidades para el hook
export const LEVELS = ['A1', 'A2', 'B1', 'B2', 'C1', 'C2'];
export const SKILLS = ['grammar', 'vocabulary', 'reading', 'listening'];



export const getQuestionsByLevel = (level) =>
  PLACEMENT_BANK.filter(q => q.level === level);

export const getQuestionsBySkill = (skill) =>
  PLACEMENT_BANK.filter(q => q.skill === skill);

export const getQuestion = (level, skill, usedIds = []) => {
  const pool = PLACEMENT_BANK.filter(
    q => q.level === level && q.skill === skill && !usedIds.includes(q.id)
  );
  if (pool.length === 0) return null;
  return pool[Math.floor(Math.random() * pool.length)];
};


export const getPlacementResult = (level) => {
  const recommendations = {
    A1: { module: 'Módulo 1',           section: 'Principiante'    },
    A2: { module: 'Módulo 3',           section: 'Elemental'       },
    B1: { module: 'Módulo 6',           section: 'Intermedio'      },
    B2: { module: 'Módulo 9',          section: 'Avanzado' },
    C1: { module: 'Practice with vocabulary', section: 'Proeficiencia'        },
    C2: { module: 'Master vocabulary and expressions', section: 'Maestría'        },
  };
  return recommendations[level] || recommendations['A1'];
};
